// Firebase uygulama başlatma, FCM/APNs messaging ve izin-temelli Analytics için kullanılır.
// Firestore ve Firebase Storage veri katmanı backend/PostgreSQL geçişi sonrası kaldırılmıştır.

import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyALhnX9sjz4T0ShjtxuidYpISOgmz15KuQ",
  authDomain: "app.aileyonetimi.com",
  projectId: "family-planner-4a240",
  storageBucket: "family-planner-4a240.firebasestorage.app",
  messagingSenderId: "875110185229",
  appId: "1:875110185229:web:0e1bfeec8c9d8cda955844",
  measurementId: "G-23W0TMTXLH",
};

const app = initializeApp(firebaseConfig);

export { app };
